<div container>
  <div class="facts d-flex flex-column gap-4 mb-4">
    <!-- #1 -->
    <div id="fact-1" class="card card--1 card--orange d-flex flex-column bg-white">
      <div class="card__title d-flex gap-4">
        <div class="number h-fit fw-extrabold">
          <span>1</span>
        </div>
        <h2>
          Adults with type 1 diabetes (T1D) and caregivers regret not learning
          sooner about the risk of developing T1D
        </h2>
      </div>
      <div class="card__content d-flex flex-column flex-lg-row">
        <div class="data d-flex align-items-center gap-1">
          <div class="data__icon">
            <img class="img-fluid" [src]="'/assets/img/costs-not-knowing/microscope.svg'" alt="A microscope" width="156"
              height="156" />
          </div>
          <div class="data__text">
            <h3>68% of adults with T1D</h3>
            <p class="mb-0">
              who did not screen say they regret not taking an autoantibody test
              to better understand their risk of developing T1D.
            </p>
          </div>
        </div>
        <div class="data d-flex align-items-center gap-1">
          <div class="data__icon">
            <img class="img-fluid" [src]="'/assets/img/costs-not-knowing/heart.svg'" alt="A heart" width="156" height="156" />
          </div>
          <div class="data__text">
            <h3>93% of caregivers</h3>
            <p class="mb-0">
              say they wish they had learned about their loved one's risk of
              developing T1D prior to their diagnosis.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- #2 -->
    <div id="fact-2" class="card card--2 card--purple d-flex flex-column bg-white">
      <div class="card__title d-flex gap-4">
        <div class="number h-fit fw-extrabold">
          <span>2</span>
        </div>
        <h2>
          “Not knowing” can have major financial, emotional and social burdens
        </h2>
      </div>
      <div class="card__content d-flex flex-column flex-lg-row">
        <div class="data d-flex flex-lg-column align-items-start gap-1">
          <div class="data__icon">
            <img class="img-fluid" [src]="'/assets/img/costs-not-knowing/coins.svg'" alt="Two stacks of coins" width="156" height="156" />
          </div>
          <div class="data__text pt-3 pt-lg-0">
            <h3>50% of adults with T1D</h3>
            <p class="mb-0">
              spent at least $5,000 on emergency care for their T1D symptoms
              before or during their diagnosis, with nearly 1 in 4 (24%)
              spending at least $10,000.
            </p>
          </div>
        </div>
        <div class="data d-flex flex-lg-column align-items-start gap-1">
          <div class="data__icon">
            <img class="img-fluid" [src]="'/assets/img/costs-not-knowing/heart--purple.svg'" alt="A heart" width="156"
              height="156" />
          </div>
          <div class="data__text pt-3 pt-lg-0">
            <h3>64% of adults with T1D</h3>
            <p class="mb-0">
              say their emotional health declined when they first received their
              diagnosis; 61% said knowing about their risk sooner would have
              helped with these feelings.
            </p>
          </div>
        </div>
        <div class="data d-flex flex-lg-column align-items-start gap-1">
          <div class="data__icon">
            <img class="img-fluid" [src]="'/assets/img/costs-not-knowing/target.svg'" alt="An arrow making a bullseye" width="156" height="156" />
          </div>
          <div class="data__text pt-3 pt-lg-0">
            <h3>71% of adults with T1D</h3>
            <p class="mb-0">
              made changes to some of their interests or plans after receiving
              their diagnosis. 37% of this group say they would not have done so
              if they had known sooner about their risk of developing T1D.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- #3 -->
    <div id="fact-3" class="card card--3 card--aqua d-flex flex-column bg-white">
      <div class="card__title d-flex gap-4">
        <div class="number h-fit fw-extrabold">
          <span>3</span>
        </div>
        <h2>
          Adults with type 1 diabetes (T1D) and caregivers regret not learning
          sooner about the risk of developing T1D
        </h2>
      </div>
      <div class="card__content d-flex flex-column flex-lg-row pe-0">
        <div class="data d-flex flex-lg-column align-items-start gap-1">
          <div class="data__icon">
            <img class="img-fluid" [src]="'/assets/img/costs-not-knowing/exclamation.svg'" alt="Exclamation points" width="156"
              height="156" />
          </div>
          <div class="data__text">
            <h3>79% of adults with T1D and 83% of caregivers</h3>
            <p class="mb-0">
              changed how they lived their life when they received their
              diagnosis.
            </p>
          </div>
        </div>
        <div class="data d-flex flex-column align-items-start gap-1">
          <div class="data__text">
            <h3 class="mb-lg-4">
              Had they screened and known sooner about their T1D
              diagnosis,&nbsp;adults with T1D say they may have:
            </h3>
          </div>
          <div class="data__img">
            <picture [data]=" {
                image: 'costs-not-knowing/card-graph',
                altext: '34% felt more in control of their health, 28% had more time to prepare, and 20% avoided the stress that comes with not knowing',
                format: '',
                width: '711',
                height: '339',
                mobile: true,
                webp: true,
                classes: 'img-fluid',
              }"></picture>
          </div>
        </div>
      </div>
    </div>

    <!-- #4 -->
    <div id="fact-4" class="card card--4 card--yellow d-flex flex-column bg-white">
      <div class="card__title d-flex gap-4">
        <div class="number h-fit fw-extrabold">
          <span>4</span>
        </div>
        <h2>
          Screening is uncommon, due largely to a lack of awareness and
          perceived barriers
        </h2>
      </div>
      <div class="card__content d-flex flex-column flex-lg-row pe-0">
        <div class="data d-flex align-items-start gap-1">
          <div class="data__icon">
            <img class="img-fluid" [src]="'/assets/img/costs-not-knowing/antibodies.svg'" alt="A magnifying glass looking at autoantibodies" width="156"
              height="156" />
          </div>
          <div class="data__text pt-3">
            <h3>Only 14% of adults with T1D</h3>
            <p class="mb-0">
              say they were screened with an autoantibody test prior to their
              diagnosis to see if they were at risk of developing the disease.
            </p>
          </div>
        </div>
        <div class="data d-flex align-items-start gap-1">
          <div class="data__icon">
            <img class="img-fluid" [src]="'/assets/img/costs-not-knowing/question.svg'" alt="A question mark" width="156"
              height="156" />
          </div>
          <div class="data__text pt-3">
            <p class="fw-bold mb-1">Among those who did not screen,</p>
            <h3>72% of adults with T1D and 66% of caregivers</h3>
            <p class="mb-0">
              say they were unaware that a T1D autoantibody test was even
              available.
            </p>
          </div>
        </div>
      </div>
      <div class="card__bottom">
        <h3 class="mb-0">
          Only 5% of adults with T1D were aware that the autoantibody test was
          available but chose not to take it.
        </h3>
      </div>
    </div>

    <!-- #5 -->
    <div id="fact-5" class="card card--5 card--orange d-flex flex-column bg-white">
      <div class="card__title d-flex gap-4">
        <div class="number h-fit fw-extrabold">
          <span>5</span>
        </div>
        <h2>
          Nearly all adults with T1D and caregivers recommend early screening
          for type 1 diabetes
        </h2>
      </div>
      <div class="card__content d-flex flex-column flex-lg-row pe-0">
        <div class="data d-flex align-items-start gap-1">
          <div class="data__icon">
            <img class="img-fluid" [src]="'/assets/img/costs-not-knowing/chat.svg'" alt="A network of people" width="156" height="156" />
          </div>
          <div class="data__text">
            <h3>92% of adults with T1D</h3>
            <p class="mb-0">
              say they would recommend friends and family members get an early
              autoantibody test for T1D to understand their risk of developing
              the disease.
            </p>
          </div>
        </div>
        <div class="data d-flex align-items-center gap-1">
          <div class="data__icon">
            <img class="img-fluid" [src]="'/assets/img/costs-not-knowing/chart.svg'" alt="A rising bar graph" width="156" height="156" />
          </div>
          <div class="data__text">
            <p class="mb-2">This jumps to</p>
            <h3 class="mb-0">96% for caregivers</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="facts__footnote d-flex gap-1">
    <span>*</span>
    <span>This research was conducted by Wakefield Research via two survey
      instruments -- one among 1,000 US adults with type 1 diabetes and a second
      among 1,000 US caregivers to those under the age of 18 years with type 1
      diabetes.</span>
  </div>
</div>